<p class="mb-2">
  <img src="assets/img/ic_help.svg" /> Finance Details
  <span *ngIf="config.add">
    <!-- <button
      (click)="addFinance('#zero_add_finance', 'Add Finance')"
      type="button"
      class="bg-main2 btn-add-1"
    >
      <i class="fa fa-plus"></i>
    </button> -->
  </span>
</p>
<div class="bg-white p-3 shadow-main border-up-down">
  <div class="row">
    <div class="col-md-6">
      <table class="font-weight-normal w-100">
        <tr *ngFor="let dat of myFinance">
          <td>
            <div class="row">
              <div class="col-md-4"><b>Bank Name</b></div>
              <div class="col-md-8">
                <a class="name"
                  >{{ dat.bank_name }}
                  <!-- <div class="edit-icon" *ngIf="config.delete">
                    <i
                      (click)="deleteFinance(dat.fin_id)"
                      class="fa fa-trash-o"
                    ></i>
                  </div>
                  <div class="edit-icon" *ngIf="config.edit">
                    <i
                      (click)="editFinance(dat.fin_id, 'Edit Finance')"
                      class="fa fa-pencil"
                    ></i>
                  </div> -->
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>Account Number</b></div>
              <div class="col-md-8">{{ dat.acc_no }}</div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>IFSC Code</b></div>
              <div class="col-md-8">{{ dat.ifsc }}</div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>Account Type</b></div>
              <div class="col-md-8">{{ dat.account_type }}</div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>Account </b></div>
              <div class="col-md-8">{{ dat.primryScndry }}</div>
            </div>
            <div class="row" *ngIf="dat.attachment != ''">
              <div class="col-md-4"><b>Attachment</b></div>
              <div class="col-md-8">
                <a
                  *ngIf="dat.attachment != ''"
                  [href]="dat.attachment"
                  title="Attachment"
                  target="_blank"
                  
                >
                  <i class="fa fa-paperclip" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-6 border-left">
      <table class="font-weight-normal w-100">
        <tr *ngIf="getRemBank?.acc_no != ''">
          <td>
            <div class="row">
              <div class="col-md-4"><b>Bank Name</b></div>
              <div class="col-md-8">
                <a class="name">{{ getRemBank?.bank_name }}</a>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>Account Number</b></div>
              <div class="col-md-8">{{ getRemBank?.acc_no }}</div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>IFSC Code</b></div>
              <div class="col-md-8">{{ getRemBank?.ifsc }}</div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>Account Type</b></div>
              <div class="col-md-8">{{ getRemBank?.account_type }}</div>
            </div>
            <div class="row">
              <div class="col-md-4"><b>Account </b></div>
              <div class="col-md-8">{{ getRemBank?.primryScndry }}</div>
            </div>
            <div class="row" *ngIf="getRemBank?.attachment != ''">
              <div class="col-md-4"><b>Attachment</b></div>
              <div class="col-md-8">
                <a
                  *ngIf="getRemBank?.attachment != ''"
                  [href]="getRemBank?.attachment"
                  title="Attachment"
                  target="_blank"
                  
                >
                  <!-- <i class="fa fa-paperclip" aria-hidden="true"></i> -->
                </a>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<div id="zero_add_finance" class="modal custom-modal fade" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">
          {{ dynamicHeader }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form
        [formGroup]="financeForm"
        (ngSubmit)="onSubmitFinance()"
        id="zero_country_form"
        class="horizontal-form"
        name="zero_country_form"
        method="post"
        enctype="multipart/form-data"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="country_name"
                  >Bank Name<span class="text-danger">*</span></label
                >
                <select2
                  [data]="myBank"
                  value="value"
                  formControlName="bank_id"
                  placeholder="Bank Name"
                ></select2>
                <div
                  *ngIf="subAdd && addErrorMsg.bank_id.errors"
                  class="form-error"
                >
                  <div *ngIf="addErrorMsg.bank_id.errors.required">
                    Bank Name is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="iso_code"
                  >Account Type<span class="text-danger">*</span></label
                >
                <select2
                  [data]="myAccountType"
                  value="value"
                  formControlName="account_type"
                  placeholder="Account Type"
                ></select2>
                <div
                  *ngIf="subAdd && addErrorMsg.account_type.errors"
                  class="form-error"
                >
                  <div *ngIf="addErrorMsg.account_type.errors.required">
                    Account type is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="iso_code"
                  >Account No.<span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  id="country_name"
                  type="text"
                  formControlName="acc_no"
                />
                <div
                  *ngIf="subAdd && addErrorMsg.acc_no.errors"
                  class="form-error"
                >
                  <div *ngIf="addErrorMsg.acc_no.errors.required">
                    Account Number is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="iso_code"
                  >IFSC Code<span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  id="country_name"
                  type="text"
                  formControlName="ifsc_code"
                />
                <div
                  *ngIf="subAdd && addErrorMsg.ifsc_code.errors"
                  class="form-error"
                >
                  <div *ngIf="addErrorMsg.ifsc_code.errors.required">
                    IFSC code is required !
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="lang">Upload Passbook / Cheque Copy </label>
                <input
                  class="form-control"
                  type="file"
                  formControlName="acc_file"
                  (change)="onFileChange($event)"
                />
                <div
                  *ngIf="subAdd && addErrorMsg.acc_file.errors"
                  class="form-error"
                >
                  <div *ngIf="addErrorMsg.acc_file.errors.required">
                    File is required !
                  </div>
                </div>
                <div>
                  <a
                    *ngIf="FileBank != ''"
                    [href]="FileBank"
                    target="_blank"
                    
                  >
                    <i class="fa fa-paperclip" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            [disabled]="loading"
            class="btn btn-primary btn-sm"
          >
            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span
            ><i class="fa fa-save"></i> SAVE
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="onResetFinance()"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
